import React from 'react';
import RawHtml from '@components/RawHtml';

type Props = {
  title: string;
  text: string;
};

function TimelineElement(props: Props) {
  const { title, text } = props;

  return (
    <div className="timeline__element">
      <div className="timeline__element-title">{title}</div>
      <div className="timeline__element-body">
        <div className="timeline__element-content">
          <RawHtml
            className="timeline__element-text richtext-wrapper"
            html={text}
          />
        </div>
      </div>
    </div>
  );
}

export default TimelineElement;
